import React from "react";
import styled from "styled-components";
import Heading from "ui/Text/Heading";

interface Props {
  className: string;
}

const ComingSoon: React.FC<Props> = ({ className }) => {
  return (
    <StyledHeading className={className} variant="h3" align="center">
      Brevemente disponíveis
    </StyledHeading>
  );
};

export default ComingSoon;

const StyledHeading = styled(Heading)`
  text-decoration: underline;
  font-weight: ${({ theme }) => theme.typography.fontWeights.semiBold};
`;
